module.exports = __webpack_public_path__ + "img/微信图片_20211224150147.09a80b9c.png";